import { ComponentType } from 'react';
import { SingleValueSelectProps, SingleValueInputProps } from 'modules/queryBuilder/contexts';
import { CatInSegInput, CatInSegInputProps } from '.';
import { MatchesCatalogComparator } from '../../../types';

export const CustomValueWithCatInSegInput = ({
  DefaultComponent,
  ...props
}: { DefaultComponent: ComponentType<any> }) => {
  const { comparator } = props as SingleValueSelectProps<string> | SingleValueInputProps<string>;
  if (comparator === (MatchesCatalogComparator.MATCHES_CATALOG_DATA as string)) {
    return <CatInSegInput {...(props as CatInSegInputProps)} />;
  }
  return <DefaultComponent {...props} />;
};
